import { atom, selector } from 'recoil';

import { getMyInfo } from 'src/api';
import { Modality } from 'src/types/api/data/image';
import { User } from 'src/types/client/user';
import { ClientErrorCode, ClientError } from 'src/utils/clientError';
import { getModalityOptions } from 'src/utils/user';

export const myInfoState = atom<User>({
  key: 'myInfoState',
  default: selector({
    key: 'user',
    get: async () => {
      const myInfo = await getMyInfo();

      if (!myInfo.isAdmin) {
        throw new ClientError({
          code: ClientErrorCode.UNAUTHORIZED,
          message: 'Only administrator is available to login!',
        });
      }

      return myInfo;
    },
  }),
});

/**
 * CCT is fully deprecated but some users still have it as a modality, so we need to filter it out to prevent errors
 */
export const myModalitiesWithoutDeprecatedCCT = selector({
  key: 'myModalitiesWithoutDeprecatedCCT',
  get: ({ get }) => {
    const user = get(myInfoState);
    const myModalities = getModalityOptions(user);
    const availableModalitiesWithoutDeprecatedCCT = myModalities.filter(
      ({ value }) => value !== Modality.DEPRECATED_CCT
    );
    return availableModalitiesWithoutDeprecatedCCT;
  },
});
